import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  AddTeamMemberModel,
  CreateOrUpdateTeamModel,
  GetMyTeamsResponse,
  GetTeamByCountryAndZipCodeParams,
  GetTeamByCountryAndZipCodeResponse,
  GetTeamByIdResponse,
  GetTeamMembersParams,
  GetTeamMembersResponse,
  GetTeamsResponse,
  ProblemDetails
} from '../../models';

import { useCustomWelcomeClient } from '../../custom-client.tsx';
import type { ErrorType } from '../../custom-client.tsx';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns a list of teams<br><br><b>Required Scopes</b><br>welcome.doka.com/onboarding<br>welcome.doka.com/onboarding-backoffice
 */
export const useGetTeamsHook = () => {
        const getTeams = useCustomWelcomeClient<GetTeamsResponse>();

        return useCallback((

 signal?: AbortSignal
) => {


        return getTeams(
          {url: `/teams`, method: 'GET', signal
    },
          );
        }, [getTeams])
      }




export const getGetTeamsQueryKey = () => {
    return [
    `/teams`
    ] as const;
    }


export const useGetTeamsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>, TError = ErrorType<ProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamsQueryKey();

  const getTeams =  useGetTeamsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>> = ({ signal }) => getTeams(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>>
export type GetTeamsQueryError = ErrorType<ProblemDetails>


export function useGetTeams<TData = Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>, TError = ErrorType<ProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeams<TData = Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeams<TData = Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTeams<TData = Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetTeamsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Creates a new team<br><br><b>Required Scopes</b><br>welcome.doka.com/onboarding-backoffice
 */
export const useCreateTeamHook = () => {
        const createTeam = useCustomWelcomeClient<GetTeamByIdResponse>();

        return useCallback((
    createOrUpdateTeamModel: CreateOrUpdateTeamModel,
 signal?: AbortSignal
) => {


        return createTeam(
          {url: `/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrUpdateTeamModel, signal
    },
          );
        }, [createTeam])
      }




export const useCreateTeamMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateTeamHook>>>, TError,CreateTeamMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateTeamHook>>>, TError,CreateTeamMutationVariables, TContext> => {

const mutationKey = ['createTeam'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createTeam =  useCreateTeamHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateTeamHook>>>, CreateTeamMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTeam(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTeamMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateTeamHook>>>>
    export type CreateTeamMutationBody = CreateOrUpdateTeamModel
    export type CreateTeamMutationError = ErrorType<ProblemDetails>
    export type CreateTeamMutationVariables = {data: CreateOrUpdateTeamModel}

    export const useCreateTeam = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateTeamHook>>>, TError,CreateTeamMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateTeamHook>>>,
        TError,
        CreateTeamMutationVariables,
        TContext
      > => {
      return useMutation(useCreateTeamMutationOptions(options), queryClient);
    }
    /**
 * Returns a team by its id<br><br><b>Required Scopes</b><br>welcome.doka.com/onboarding<br>welcome.doka.com/onboarding-backoffice
 */
export const useGetTeamByIdHook = () => {
        const getTeamById = useCustomWelcomeClient<GetTeamByIdResponse>();

        return useCallback((
    id: string,
 signal?: AbortSignal
) => {


        return getTeamById(
          {url: `/teams/${id}`, method: 'GET', signal
    },
          );
        }, [getTeamById])
      }




export const getGetTeamByIdQueryKey = (id: string,) => {
    return [
    `/teams/${id}`
    ] as const;
    }


export const useGetTeamByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>, TError = ErrorType<ProblemDetails>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamByIdQueryKey(id);

  const getTeamById =  useGetTeamByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>> = ({ signal }) => getTeamById(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>>
export type GetTeamByIdQueryError = ErrorType<ProblemDetails>


export function useGetTeamById<TData = Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>, TError = ErrorType<ProblemDetails>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamById<TData = Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>, TError = ErrorType<ProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamById<TData = Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>, TError = ErrorType<ProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTeamById<TData = Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>, TError = ErrorType<ProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamByIdHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetTeamByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Removes a contributor from a team<br><br><b>Required Scopes</b><br>welcome.doka.com/onboarding-backoffice
 */
export const useRemoveTeamMemberHook = () => {
        const removeTeamMember = useCustomWelcomeClient<void>();

        return useCallback((
    id: string,
    contributorId: string,
 signal?: AbortSignal
) => {


        return removeTeamMember(
          {url: `/teams/${id}/contributor/${contributorId}`, method: 'DELETE', signal
    },
          );
        }, [removeTeamMember])
      }




export const useRemoveTeamMemberMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRemoveTeamMemberHook>>>, TError,RemoveTeamMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRemoveTeamMemberHook>>>, TError,RemoveTeamMemberMutationVariables, TContext> => {

const mutationKey = ['removeTeamMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const removeTeamMember =  useRemoveTeamMemberHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useRemoveTeamMemberHook>>>, RemoveTeamMemberMutationVariables> = (props) => {
          const {id,contributorId} = props ?? {};

          return  removeTeamMember(id,contributorId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveTeamMemberMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useRemoveTeamMemberHook>>>>

    export type RemoveTeamMemberMutationError = ErrorType<ProblemDetails>
    export type RemoveTeamMemberMutationVariables = {id: string;contributorId: string}

    export const useRemoveTeamMember = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRemoveTeamMemberHook>>>, TError,RemoveTeamMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useRemoveTeamMemberHook>>>,
        TError,
        RemoveTeamMemberMutationVariables,
        TContext
      > => {
      return useMutation(useRemoveTeamMemberMutationOptions(options), queryClient);
    }
    /**
 * Adds a contributor to a team<br><br><b>Required Scopes</b><br>welcome.doka.com/onboarding-backoffice
 */
export const useAddTeamMemberHook = () => {
        const addTeamMember = useCustomWelcomeClient<void>();

        return useCallback((
    id: string,
    addTeamMemberModel: AddTeamMemberModel,
 signal?: AbortSignal
) => {


        return addTeamMember(
          {url: `/teams/${id}/members`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: addTeamMemberModel, signal
    },
          );
        }, [addTeamMember])
      }




export const useAddTeamMemberMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddTeamMemberHook>>>, TError,AddTeamMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddTeamMemberHook>>>, TError,AddTeamMemberMutationVariables, TContext> => {

const mutationKey = ['addTeamMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const addTeamMember =  useAddTeamMemberHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAddTeamMemberHook>>>, AddTeamMemberMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  addTeamMember(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddTeamMemberMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAddTeamMemberHook>>>>
    export type AddTeamMemberMutationBody = AddTeamMemberModel
    export type AddTeamMemberMutationError = ErrorType<ProblemDetails>
    export type AddTeamMemberMutationVariables = {id: string;data: AddTeamMemberModel}

    export const useAddTeamMember = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddTeamMemberHook>>>, TError,AddTeamMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useAddTeamMemberHook>>>,
        TError,
        AddTeamMemberMutationVariables,
        TContext
      > => {
      return useMutation(useAddTeamMemberMutationOptions(options), queryClient);
    }
    /**
 * Get all team members<br><br><b>Required Scopes</b><br>welcome.doka.com/onboarding-backoffice
 */
export const useGetTeamMembersHook = () => {
        const getTeamMembers = useCustomWelcomeClient<GetTeamMembersResponse>();

        return useCallback((
    id: string,
    params?: GetTeamMembersParams,
 signal?: AbortSignal
) => {


        return getTeamMembers(
          {url: `/teams/${id}/members`, method: 'GET',
        params, signal
    },
          );
        }, [getTeamMembers])
      }




export const getGetTeamMembersQueryKey = (id: string,
    params?: GetTeamMembersParams,) => {
    return [
    `/teams/${id}/members`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetTeamMembersQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>, TError = ErrorType<ProblemDetails>>(id: string,
    params?: GetTeamMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamMembersQueryKey(id,params);

  const getTeamMembers =  useGetTeamMembersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>> = ({ signal }) => getTeamMembers(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamMembersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>>
export type GetTeamMembersQueryError = ErrorType<ProblemDetails>


export function useGetTeamMembers<TData = Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>, TError = ErrorType<ProblemDetails>>(
 id: string,
    params: undefined |  GetTeamMembersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamMembers<TData = Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>, TError = ErrorType<ProblemDetails>>(
 id: string,
    params?: GetTeamMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamMembers<TData = Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>, TError = ErrorType<ProblemDetails>>(
 id: string,
    params?: GetTeamMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTeamMembers<TData = Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>, TError = ErrorType<ProblemDetails>>(
 id: string,
    params?: GetTeamMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamMembersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetTeamMembersQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns a team by its country id and optional zip code<br><br><b>Required Scopes</b><br>welcome.doka.com/onboarding-backoffice
 */
export const useGetTeamByCountryAndZipCodeHook = () => {
        const getTeamByCountryAndZipCode = useCustomWelcomeClient<GetTeamByCountryAndZipCodeResponse>();

        return useCallback((
    countryConfigurationId: string,
    params?: GetTeamByCountryAndZipCodeParams,
 signal?: AbortSignal
) => {


        return getTeamByCountryAndZipCode(
          {url: `/teams/country/${countryConfigurationId}`, method: 'GET',
        params, signal
    },
          );
        }, [getTeamByCountryAndZipCode])
      }




export const getGetTeamByCountryAndZipCodeQueryKey = (countryConfigurationId: string,
    params?: GetTeamByCountryAndZipCodeParams,) => {
    return [
    `/teams/country/${countryConfigurationId}`, ...(params ? [params] : [])
    ] as const;
    }


export const useGetTeamByCountryAndZipCodeQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>, TError = ErrorType<ProblemDetails>>(countryConfigurationId: string,
    params?: GetTeamByCountryAndZipCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamByCountryAndZipCodeQueryKey(countryConfigurationId,params);

  const getTeamByCountryAndZipCode =  useGetTeamByCountryAndZipCodeHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>> = ({ signal }) => getTeamByCountryAndZipCode(countryConfigurationId,params, signal);





   return  { queryKey, queryFn, enabled: countryConfigurationId !== null && countryConfigurationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamByCountryAndZipCodeQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>>
export type GetTeamByCountryAndZipCodeQueryError = ErrorType<ProblemDetails>


export function useGetTeamByCountryAndZipCode<TData = Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>, TError = ErrorType<ProblemDetails>>(
 countryConfigurationId: string,
    params: undefined |  GetTeamByCountryAndZipCodeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamByCountryAndZipCode<TData = Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>, TError = ErrorType<ProblemDetails>>(
 countryConfigurationId: string,
    params?: GetTeamByCountryAndZipCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamByCountryAndZipCode<TData = Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>, TError = ErrorType<ProblemDetails>>(
 countryConfigurationId: string,
    params?: GetTeamByCountryAndZipCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTeamByCountryAndZipCode<TData = Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>, TError = ErrorType<ProblemDetails>>(
 countryConfigurationId: string,
    params?: GetTeamByCountryAndZipCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTeamByCountryAndZipCodeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetTeamByCountryAndZipCodeQueryOptions(countryConfigurationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Get all teams for the current user<br><br><b>Required Scopes</b><br>welcome.doka.com/onboarding-backoffice
 */
export const useGetMyTeamsHook = () => {
        const getMyTeams = useCustomWelcomeClient<GetMyTeamsResponse>();

        return useCallback((

 signal?: AbortSignal
) => {


        return getMyTeams(
          {url: `/teams/my`, method: 'GET', signal
    },
          );
        }, [getMyTeams])
      }




export const getGetMyTeamsQueryKey = () => {
    return [
    `/teams/my`
    ] as const;
    }


export const useGetMyTeamsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>, TError = ErrorType<ProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyTeamsQueryKey();

  const getMyTeams =  useGetMyTeamsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>> = ({ signal }) => getMyTeams(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyTeamsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>>
export type GetMyTeamsQueryError = ErrorType<ProblemDetails>


export function useGetMyTeams<TData = Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>, TError = ErrorType<ProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyTeams<TData = Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyTeams<TData = Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyTeams<TData = Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetMyTeamsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetMyTeamsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






